'use strict';

var jsxRuntime = require('react/jsx-runtime');

const LargeLike = ({ testId, className, solid })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsx("path", {
                    d: "M6.56006 10.41H5.42006C4.25006 10.41 3.31006 11.38 3.31006 12.57V19.04C3.31006 19.61 3.52006 20.15 3.92006 20.56C4.31006 20.96 4.86006 21.2 5.42006 21.21H6.56006V10.42V10.41Z",
                    fill: "currentColor"
                }),
                jsxRuntime.jsx("path", {
                    d: "M20.7 13.93V11.87C20.7 10.26 19.63 9.60003 18.58 9.52003H13.97L14.39 6.49003C14.65 4.74003 14.03 3.93003 13.64 3.60003L13.14 3.18003C13.14 3.18003 13.07 3.11003 13.06 3.11003C12.65 2.75003 12.24 2.79003 12.04 2.85003C11.46 3.01003 11.21 3.61003 11.19 3.65003L7.95996 10.42V21.22H8.39996C8.39996 21.22 8.41996 21.22 8.43996 21.22H15.97C16.72 21.22 17.44 20.84 17.98 20.16C18.19 19.9 18.3 19.68 18.31 19.66L19.79 16.92C19.95 16.64 20.07 16.39 20.18 16.16C20.2 16.12 20.22 16.08 20.23 16.04C20.76 14.79 20.71 13.98 20.71 13.96L20.7 13.93Z",
                    fill: "currentColor"
                })
            ]
        }) : jsxRuntime.jsx("path", {
            d: "M8.40001 20.5H5.42001C5.04001 20.5 4.68001 20.34 4.42001 20.07C4.16001 19.8 4.01001 19.43 4.01001 19.05V12.57C4.01001 11.77 4.65001 11.11 5.42001 11.11H8.40001M19.55 15.8C20.06 14.63 20 13.93 20 13.93V11.87C20 10.51 19.08 10.26 18.58 10.22H13.16L13.69 6.39C13.9 4.93 13.42 4.33 13.18 4.13L12.66 3.69L12.59 3.63C12.13 3.23 11.82 3.92 11.81 3.94L8.39001 11.11V20.5H15.96C16.66 20.5 17.15 20.05 17.42 19.7C17.59 19.48 17.68 19.31 17.68 19.31L19.17 16.55C19.31 16.3 19.43 16.07 19.52 15.85L19.54 15.81L19.55 15.8Z",
            stroke: "currentColor",
            strokeWidth: "1.4",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};

module.exports = LargeLike;
